import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Loader from '../Loader/Loader';
import FormCheckbox from '../form/FormCheckbox/FormCheckbox';
import ReSignWrapper from './ReSignWrapper';
import ReSignError from './ReSignError';
import ReSignSuccess from './ReSignSuccess';
import ReSignCustomerInfo from './ReSignCustomerInfo';
import ReSignContact from './ReSignContact';
import loader from '../../assets/loading.gif';
import './ReSign.scss';

class ReSign extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      termsAccepted: false
    };
    this.props.getCustomerInfo(this.props.location.query.token);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleTermsClicked = this.handleTermsClicked.bind(this);
    this.hasError = this.hasError.bind(this);
  }

  handleConfirm(event) {
    event.preventDefault();
    this.setState({ ...this.state, processing: true });
    this.props.reSign(this.props.location.query.token);
  }

  handleTermsClicked() {
    this.setState({ ...this.state, termsAccepted: !this.state.termsAccepted });
  }

  hasError() {
    return this.props.error.status;
  }

  render() {
    const { error, info, response } = this.props;
    const input = {
      onClick: this.handleTermsClicked
    };
    return (
      <div>
        {!info && !this.hasError() ?
          <ReSignWrapper title="Skinny Re-sign">
            <div className="loader-container"><Loader /></div>
          </ReSignWrapper> : null
        }
        {this.hasError() ?
          <ReSignWrapper title="Skinny Re-sign">
            <ReSignError error={error} />
          </ReSignWrapper> : null
        }
        {info && !response && !this.hasError() ?
          <ReSignWrapper title={`Get ${info.resignPromoText ? `${info.resignPromoText} ` : ''}Broadband on us!`}>
            <ReSignCustomerInfo info={info} />
            {info.linkValid ?
              <div>
                <div className="button-container">
                  <div>
                    <FormCheckbox id="terms-agree" name="terms-agree" input={input}>
                      <div>
                        By clicking &quot;submit order&quot;, you agree to the&nbsp;
                        <a
                          href="https://www.skinny.co.nz/terms#UBB"
                          target="_blank"
                          rel="noopener noreferrer"
                        >Skinny terms and conditions</a>.
                      </div>
                    </FormCheckbox>
                  </div>
                  <Button
                    id="change-confirm-confirm"
                    onClick={this.handleConfirm}
                    disabled={(this.state.processing && !this.hasError()) || !this.state.termsAccepted}
                  >
                    {this.state.processing && !this.hasError() ?
                      <img src={loader} height="20" alt="Loading..." role="presentation" /> : 'Submit order'
                    }
                  </Button>
                </div>
                <div>
                  <p>
                    Do we have the wrong details? Not to worry, you can still grab this sweet deal, all you need to
                    do is get in touch with us via one of the options below. Let us know what details are incorrect,
                    and we can work our magic to make this happen!
                  </p>
                  <ReSignContact name={`${info.givenName} ${info.surname}`} email={info.email} />
                  <h4>Things you should know:</h4>
                  <p>
                    Got some more questions?&nbsp;
                    <a href="https://www.skinny.co.nz/broadbandresign" target="_blank" rel="noopener noreferrer">
                      Visit our FAQ page
                    </a>.<br />
                  </p>
                </div>
              </div>
              : null
            }
          </ReSignWrapper> : null
        }
        {response ?
          <ReSignWrapper title="Woohoo!">
            <ReSignSuccess info={info} />
          </ReSignWrapper> : null
        }
      </div>
    );
  }
}

ReSign.propTypes = {
  location: PropTypes.object,
  error: PropTypes.object,
  info: PropTypes.object,
  response: PropTypes.object,
  getCustomerInfo: PropTypes.func,
  reSign: PropTypes.func
};

export default ReSign;



/** WEBPACK FOOTER **
 ** ./src/components/ReSign/ReSign.js
 **/